import { render, staticRenderFns } from "./status-column.vue?vue&type=template&id=b8db2b18"
import script from "./status-column.vue?vue&type=script&lang=js"
export * from "./status-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports